export default "__VITE_ASSET__3baad12f__"